import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Route, Switch, NavLink, Redirect, withRouter } from 'react-router-dom';

import styles from './styles';
import NotificationSettingsContainer from '../NotificationSettingsContainer';

const propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string,
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};

export const SettingsContainer = props => {
  const { classes, location } = props;

  if (location.pathname === '/settings') {
    // Redirect to notification settings by default
    return <Redirect to="/settings/notifications" />;
  }

  return (
    // <LeftSidebarPageContainer>
    <div className={classes.root}>
      <div className={classes.innerWrapper}>
        <h1 className={classes.heading}>Settings</h1>
      </div>
      <div className={classes.innerWrapper}>
        <ul className={classes.nav}>
          <li>
            <NavLink
              activeClassName={classes.activeLink}
              to="/settings/notifications"
            >
              JOB NOTIFICATION
            </NavLink>
          </li>
        </ul>
      </div>
      <Switch>
        <Route
          path="/settings/notifications"
          component={NotificationSettingsContainer}
        />
      </Switch>
    </div>
    // </LeftSidebarPageContainer>
  );
};

SettingsContainer.propTypes = propTypes;

export default withRouter(withStyles(styles)(SettingsContainer));
